import type { RouteRecordRaw } from 'vue-router';
import { authRoutes } from './routes/auth';
import { employeeRoutes } from './routes/employee';
import { reviewRoutes } from './routes/review';
import { serviceRoutes } from './routes/service';
import { turnTrackerRoutes } from './routes/turn-tracker';
import { promotionRoutes } from './routes/promotion';

const routes: RouteRecordRaw[] = [
  employeeRoutes,
  authRoutes,
  reviewRoutes,
  serviceRoutes,
  turnTrackerRoutes,
  promotionRoutes,
];

export default routes;
